"use client";

import { ErrorState } from "@/components/errorState/ErrorState";
import { RenderError } from "@/types/defs/errorState";

// Catches crashes thrown by the nested layouts themselves (e.g. user loading in the application layout) — no shell is available, so it renders full-page.
export default function RootError({
  error,
  reset,
}: {
  error: RenderError;
  reset: () => void;
}) {
  return (
    <div className="flex min-h-screen flex-col justify-center">
      <ErrorState error={error} reset={reset} boundary="root" />
    </div>
  );
}
